import { IBFHistoryRecordDefinition } from "@/lib/drivers/insulet/IBFHistoryLogs/HistoryRecordParser";

export type IBFBloodGlucose = {
  errorCode: number;
  glucose: number;
  userTag1: string;
  userTag2: string;
  flags: number;
};

export const IBF_BLOOD_GLUCOSE = {
  value: 0x0800,
  name: "IBF_BLOOD_GLUCOSE",
  size: 55,
  parse: (record): IBFBloodGlucose => {
    const errorCode = record.nextUInt32LE();
    const glucose = record.nextUInt16LE();
    const userTag1 = record.nextString(24);
    const userTag2 = record.nextString(24);
    const flags = record.nextUInt8();
    return {
      errorCode,
      glucose,
      userTag1,
      userTag2,
      flags,
    };
  },
} satisfies IBFHistoryRecordDefinition<IBFBloodGlucose>;
